// extracted by mini-css-extract-plugin
export default {"container":"style_container__VE1zv","titleSection":"style_titleSection__Ua8Qa"};